export interface NavigationItem {
    labelKey: string;
    path: string;
}

export const primaryNavigation: NavigationItem[] = [
    { labelKey: 'nav.services', path: '/services' },
    { labelKey: 'nav.work', path: '/work' },
    { labelKey: 'nav.about', path: '/about' }
];

export const studioNavigation: NavigationItem[] = [
    { labelKey: 'nav.services', path: '/services' },
    { labelKey: 'nav.work', path: '/work' },
    { labelKey: 'nav.ai', path: '/ai' },
    { labelKey: 'nav.about', path: '/about' },
    { labelKey: 'nav.support', path: '/support' }
];

export const legalNavigation: NavigationItem[] = [
    { labelKey: 'footer.imprint', path: '/imprint' },
    { labelKey: 'footer.privacy', path: '/privacy-policy' },
    { labelKey: 'footer.terms', path: '/terms-of-service' },
    { labelKey: 'footer.cookies', path: '/cookie-policy' }
];

export const SITE_ORIGIN = 'https://haukel.com';

export const SOCIAL_IMAGE_PATH = '/theme/assets/haukel-social.jpg';

export const CONTACT_EMAIL = 'service@haukel.de';

export const CONTACT_PATH = '/contact';

export function mailtoHref(subject: string, body?: string): string {
    const query = new URLSearchParams(body ? { subject, body } : { subject });
    return `mailto:${CONTACT_EMAIL}?${query.toString().replace(/\+/g, '%20')}`;
}

export const SOCIAL_LINKS = [
    { label: 'X', href: 'https://x.com/Haukel_', icon: 'x' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/haukel', icon: 'linkedin' }
] as const;
